// Header legado das páginas de revenda: agora usa a navbar do novo design.
import NavbarFlow from "@/components/navbar/NavbarFlow";

export default function HeaderRevenda() {
  return <NavbarFlow />;
}
